import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", { class: "mark p-2" }, "各種メモ", -1)
const _hoisted_2 = { class: "row p-2" }
const _hoisted_3 = { class: "col-md-4" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("dl", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notes, (note, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          _createElementVNode("dt", _hoisted_3, [
            _createElementVNode("a", {
              href: note.url,
              target: "_blank"
            }, _toDisplayString(note.title), 9, _hoisted_4)
          ]),
          _createElementVNode("dd", {
            class: "col-md-8",
            innerHTML: note.text
          }, null, 8, _hoisted_5)
        ], 64))
      }), 128))
    ])
  ], 64))
}